import request from '@/utils/request'

export function getIndexLeft() {
  return request({
    url: 'api/v1/index/indexLeft',
    method: 'get'
  })
}

export function getIndexMiddle() {
  return request({
    url: 'api/v1/index/indexMiddle',
    method: 'get'
  })
}

export function getPriceChart(data) {
  return request({
    url: 'api/v1/index/getPriceChart',
    method: 'post',
    data: data
  })
}

export function getUserChart(data) {
  return request({
    url: 'api/v1/index/getUserRegChart',
    method: 'post',
    data: data
  })
}

export function getIndexPayStat(data) {
  return request({
    url: 'api/v1/index/getIndexPayStat',
    method: 'post',
    data: data
  })
}

export function getIndexPlatStat(data) {
  return request({
    url: 'api/v1/index/getIndexPlatStat',
    method: 'post',
    data: data
  })
}

export function getIndexFirstPayStat(data) {
  return request({
    url: 'api/v1/index/getIndexFirstPayStat',
    method: 'post',
    data: data
  })
}

export function getDatStat(data) {
  return request({
    url: 'api/v1/index/getIndexDayStat',
    method: 'post',
    data: data,
    timeout: 50000
  })
}

